/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RangeLevel {
  Poor = 'Poor',
  Fair = 'Fair',
  Average = 'Average',
  Good = 'Good',
  Excellent = 'Excellent'
}
